// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"5024f0a6","417":"29803a5e"}[chunkId] + ".chunk.css";
};